module.exports = __webpack_public_path__ + "static/img/prism_loader.cd8a9eb.gif";


//////////////////
// WEBPACK FOOTER
// ./static/prism_admin/images/prism_loader.gif
// module id = JC6f
// module chunks = 60